import React, { useEffect, useState } from 'react';
import { FormControl, Select, MenuItem, FormHelperText } from '@mui/material';
import styles from '../PartCard/PartCard.module.scss';
import { useTranslation } from 'react-i18next';
import { getManifoldGroups } from '../../utils/Utils';
import { GetSystemResponse, Group } from '../../models/Api';

function ManifoldsDropdownList(props: { system: GetSystemResponse; shouldValidate: boolean; setSelection: (manifoldId: string) => void }) {
  const { t } = useTranslation();
  const [manifolds, setManifolds] = useState<Group[]>([]);
  const [selectedManifoldGroupId, setSelectedManifoldGroupId] = useState<number>(-1);

  useEffect(() => {
    setManifolds(getManifoldGroups(props.system) as Group[]);
  }, [props.system]);

  const selectedManifoldGroup = manifolds?.find((manifold) => manifold.id === selectedManifoldGroupId);
  return (
    <FormControl className={styles['modal-input-field']} size="small">
      <Select
        color="secondary"
        displayEmpty
        value={selectedManifoldGroupId > 0 ? selectedManifoldGroupId.toString() : ''}
        onChange={(e) => {
          setSelectedManifoldGroupId(Number.parseInt(e.target.value));
          props.setSelection(e.target.value);
        }}
        renderValue={() => {
          if (selectedManifoldGroupId === -1) {
            return <span>{t('SelectManifold')}</span>;
          }
          return <span>{t('SelectedManifold', { selectedManifoldGroup })}</span>;
        }}
      >
        {manifolds?.map((group) => {
          return (
            <MenuItem key={group.id} value={group.id}>
              {group.name}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText error>{props.shouldValidate && selectedManifoldGroupId === -1 && t('SelectManifold')}</FormHelperText>
    </FormControl>
  );
}

export default ManifoldsDropdownList;
